import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { LogRocketService } from '@core/observability/logrocket/logrocket.service';
import { catchError, EMPTY } from 'rxjs';

export function provideLogRocket(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const logRocketService = inject(LogRocketService);
      return logRocketService.init().pipe(
        catchError(err => {
          console.error('Unable to initialize LogRocket', err);
          return EMPTY;
        })
      );
    })
  ]);
}
